import React from "react"
import Form from "react-bootstrap/Form"

export interface RadioButtonProps {
  selected: boolean
  onToggle: (e: any) => void
  indeterminate?: boolean
}

const RadioButton = (props: RadioButtonProps) => {
  const toggle = (e: any) => {
    props.onToggle(e)
    console.log("toggled: " + e.id)
  }

  const dummy = () => {} // To silence react warning of controlled checkboxes.

  return (
    <Form.Group className="mb-0">
      <div className="custom-control custom-radio">
        <Form.Control
          type="radio"
          className="custom-control-input"
          checked={props.selected}
          onChange={dummy}
          //   ref={(e: any) => e && (e.indeterminate = props.indeterminate)}
        />
        <Form.Label className="custom-control-label" onClick={toggle}>
          {""}
        </Form.Label>
      </div>
    </Form.Group>
  )
}

export default RadioButton
